import { css, styled } from '../../../common.styles';
import { baseColor, normalFont, primaryFont } from '../../../styles/general/theme';
import { CommonTypography } from '../general/typography';

export type PeuFontSize = 10 | 11 | 12 | 13 | 14 | 15 | 16 | 18 | 20 | 22 | 24 | 25 | 26 | 28 | 30 | 34 | 36 | 40 | 60;

const BasicPeuTextStyle = css<{ size?: PeuFontSize }>`
  font-size: ${(p) => p.size || 10}px;
  line-height: 1.2;
  color: ${(p) => p.theme.color.base[100]};
`;

const BasicPeuText = styled.div<{ size?: PeuFontSize }>`
  ${BasicPeuTextStyle}
`;

const PeuTitleStyle = css`
  ${BasicPeuTextStyle};
  font-family: ${(p) => p.theme.font.accent};
  text-transform: uppercase;
`;

const PeuCenterTitleStyle = css`
  ${BasicPeuTextStyle};
  ${PeuTitleStyle};
  font-size: ${(p) => p.size || 15}px;
  font-weight: 700;
  line-height: 25px;
  text-align: center;
  margin: 36px 0;
  color: ${(p) => p.theme.color.base[400]};
`;

const PeuTitle = styled.div<{ size: PeuFontSize }>`
  ${PeuTitleStyle}
`;

const PeuCenterTitle = styled.div<{ size: PeuFontSize }>`
  ${PeuCenterTitleStyle}
`;

const GreyPeuTitle = styled(PeuTitle)`
  color: ${(p) => p.theme.color.base[300]};
`;

const PeuTextStyle = css`
  ${BasicPeuTextStyle};
  font-family: ${primaryFont};
`;

const PeuNormalTextStyle = css`
  ${BasicPeuTextStyle};
  font-family: ${normalFont};
`;

const PeuText = styled.div<{ size: PeuFontSize }>`
  ${PeuTextStyle}
`;

const PeuNormalText = styled.div<{ size?: PeuFontSize }>`
  ${PeuNormalTextStyle}
`;

const GreyPeuText = styled(PeuText)`
  color: ${(p) => p.theme.color.base[300]};
`;

const PeuAccentText = styled(BasicPeuText)`
  font-family: ${(p) => p.theme.font.accent};
`;

const PeuBoldText = styled(BasicPeuText)`
  font-family: ${(p) => p.theme.font.secondary};
`;

const PeuHighlightedText = styled(PeuBoldText)`
  color: ${(p) => p.theme.color.primary[500]};
`;

const PeuHighlightedTitle = styled(PeuTitle)`
  color: ${(p) => p.theme.color.primary[500]};
`;

const PeuButtonTitle = styled(PeuTitle)`
  color: ${(p) => p.theme.color.base[900]};
`;

const PeuLegalTextStyle = css`
  color: ${baseColor(100)};
  font-family: ${normalFont};
  font-size: 10px;
  line-height: 12px;
`;

const PeuLegalText = styled.div`
  ${PeuLegalTextStyle};
`;

const NormalBoldTitleStyle = css`
  ${PeuTitleStyle};
  font-weight: bold;
`;

const NormalCenterBoldTitleStyle = css`
  ${PeuCenterTitleStyle};
  font-weight: bold;
`;

const NormalBoldTitle = styled.div`
  ${NormalBoldTitleStyle}
`;

const NormalCenterBoldTitle = styled.div`
  ${NormalCenterBoldTitleStyle}
`;

export const Typography = {
  ...CommonTypography,
  BasicPeuText,
  PeuTitle,
  PeuCenterTitle,
  GreyPeuTitle,
  PeuText,
  PeuNormalText,
  GreyPeuText,
  PeuAccentText,
  PeuBoldText,
  PeuHighlightedText,
  PeuHighlightedTitle,
  PeuButtonTitle,
  PeuLegalText,
  NormalBoldTitle,
  NormalCenterBoldTitle,
  styles: {
    BasicPeuTextStyle,
    PeuLegalTextStyle,
    PeuTextStyle,
    PeuTitleStyle,
    PeuNormalTextStyle,
    NormalBoldTitleStyle,
    NormalCenterBoldTitleStyle,
  },
};
